<template>
    <div class="filter-item" :class="{'filter-item--active': isActive}">
        <button
            class="btn my-collapse-btn"
            type="button"
            data-toggle="collapse"
            :data-target="'#' + panelId"
            :aria-expanded="expanded ? 'true' : 'false'"
            :aria-controls="panelId"
        >
            <span class="filter-item__title">
                {{ title }}
                <span v-if="isActive" class="filter-item__dot" aria-hidden="true"></span>
            </span>
            <i class="bi bi-plus" aria-hidden="true"></i>
        </button>
        <div class="collapse" :class="{'show': expanded}" :id="panelId">
            <div class="my-collapse-body">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FilterAccordion',
    props: {
        panelId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
